import React, { useState, useEffect } from "react";

import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  Grid,
} from "@material-ui/core";
import UsersByRole from "../../NewInvoice/Dropdowns/UsersByRole";
import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../InvoiceDetails/style";
import { useNavigate } from "react-router-dom";
import { updateIR, getAllUsersByRole, getCommentsByInvoiceId } from "../../actions";
import jwt from "jsonwebtoken";

const useStyles = makeStyles(dashboardStyle);

const ChangeIrModal = ({
  open,
  close,
  Invoice_Id,
  setSuccessMessage,
  setErrorMessage,
  setLoading,
  loading,
  setCommentsList,
        setCommentsLoading,
        invoicePayload , 
        setcount
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [formState, setFormState] = useState({
    Invoice_Id: Invoice_Id,
    IRUser: "",
    comment : ""
  });
  const [filterloginUser, setFilterLoginUser] = useState([]);
  const [userData, setUserData] = useState([]);
  const [Filter, setfilter] = useState([]);

  const token = localStorage.getItem("user_token");
  const user = jwt.decode(token);

  const getUsers = async () => {
    getAllUsersByRole("IR", setUserData, setLoading);
  };
  useEffect(() => {
    getUsers();
  }, []);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;
    console.log(name, value , "name value")
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };

  console.log(formState, "formState")
  const submitHandler = (e) => {
    e.preventDefault();
    updateIR(
      formState,
      undefined,
      setSuccessMessage,
      setErrorMessage,
      setLoading,
      close,
      navigate , 
      setCommentsList,
      setCommentsLoading,
      invoicePayload ,
      setcount
    
    );
  };
  return (
    <Dialog open={open} onClose={close} fullWidth>
      <form onSubmit={submitHandler}>
        <DialogTitle>
          <Typography>Change IR</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            IR User<span className={classes.asterisk}>*</span>
          </Typography>

          <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-name-label">Select IR</InputLabel>
            <Select
              labelId="demo-simple-name-label"
              id="demo-simple-name"
              label="Select IR"
              name="IRUser"
              value={formState.IRUser}
              onChange={changeHandler}
              MenuProps={MenuProps}
            >
              {!loading ? (
                userData.length > 0 ? (
                  userData
                    ?.filter((item) => {
                      return item.userId != user?.LoginId;
                    })
                    .map((item, index) => (
                      <MenuItem key={index} value={item.userId}>
                        {item.userName}
                      </MenuItem>
                    ))
                ) : (
                  <MenuItem disabled>Not Found</MenuItem>
                )
              ) : (
                <MenuItem>
                  <CircularProgress size={24} />
                </MenuItem>
              )}
            </Select>
          </FormControl>

             <Grid>
                        <Typography style={{ color: "black" }}>
                          <span style= {{color:"red"}}>
                            *
                          </span>
                                   Comments:
                                  {/* <span className={classes.asterisk}>*</span> */}
                                </Typography>
                                <TextField
                                  fullWidth
                                  multiline
                                  name="comment"
                                  value={formState?.comment}
                                  onChange={changeHandler}
                                  // rows={2}
                                  maxRows={4}
                                  // size="small"
                                  sx={{
                                    // width: "70%",
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                  }}
                                  id="outlined-basic"
                                  variant="outlined"
                                  // disabled={disable}
                                  required
                                />
                        </Grid>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="outlined" onClick={close}>
            Close
          </Button>
          <Button color="secondary" variant="contained" type="submit">
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ChangeIrModal;
